import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useStore, { selectCountryTheme } from '@/hooks/client/useStore';

const css = {
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
  backdrop: {
    color: '#fff',
    zIndex: 5,
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  circularProgress: (color) => ({ color: color, mb: 3 }),
};

const LoadingProduct = () => {
  const countryTheme = useStore(selectCountryTheme);
  return (
    <Backdrop sx={css.backdrop} open={true}>
      <Box sx={css.loading}>
        <CircularProgress
          sx={css.circularProgress(countryTheme.accentColor)}
          size={55}
          disableShrink
        />
        <Typography variant="h3">Buscando lote...</Typography>
      </Box>
    </Backdrop>
  );
};

export default LoadingProduct;
